import { useState } from "react";
import { Close, CloseIcon, ContactMeContainer, ContactMeContent, ContactMeHeadline, ContactMeSubtitle, ModalInputContainer, ModalInput, ErrorMessage, Button, Back } from "./HelpForm.style";
import { BloomreachLeadModel } from "../../../../types/BloomreachLeadModal";
import { useStore } from "../../../../store/store";
import { postBloomreachLead } from "../../../../utils/api";
import Analytics from "../../../../utils/analytics";
import { VisibleLayoutEnum } from "../../FormEnrollmentNew";

interface Props {
    onClose: () => void;
    chosenProducts: string | undefined;
}

export default function HelpForm({onClose, chosenProducts} : Props) {
    const [firstName, setFirstName] = useState<string>();
    const [mobile, setMobile] = useState<string>();
    //const [email, setEmail] = useState<string>();
    const [showMobileError, setShowMobileError] = useState<boolean>(false);
    const [showFirstNameError, setShowFirstNameError] = useState<boolean>(false);
    //const [showEmailError, setShowEmailError] = useState<boolean>(false);
    //const [consentChecked, setConsentChecked] = useState<boolean>(false);
    //const [showConsentError, setShowConsentError] = useState<boolean>(false);
    const setSwitchLayout = useStore.useSetSwitchLayout();
    const payload = useStore.usePayload()

    const onSend = async () => {
        const chosenProductText = chosenProducts !== "" && chosenProducts !== undefined ? `ring mig op om: ${chosenProducts}` : ", ingen produkter valgt"
        let lead = {} as BloomreachLeadModel;
        lead.firstName = firstName as string
        lead.phone = mobile as string
        lead.campaign = "Ring mig op"
        lead.source = `OI kurv` as string
        lead.occupation =  payload.occupation as string
        lead.comment = `${chosenProductText}`

        await postBloomreachLead({
            ...lead
            }).then(() => {
            Analytics.getInstance().trackContactLeanModalSubmitted()
            onClose();
            setSwitchLayout(VisibleLayoutEnum.CallMeReciept)
            });
    } 

    //Rollback extended consent and email removed form lead. 07-2025
  /*   const getEmailIsValid = (value: string) => {
        const normalizedEmail = value.trim();
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail);
    } */

    //Validation for contact me inputs
    const checkSubmit = () => {
        if ((firstName != undefined && firstName != "") && (mobile != undefined && mobile != "") /* && (email && getEmailIsValid(email)) && consentChecked */) {
            onSend()
            setFirstName("");
            setMobile("");
            //setEmail("");
            //setConsentChecked(false);
            setShowMobileError(false);
            setShowFirstNameError(false);
            //setShowEmailError(false);
            //setShowConsentError(false);
        } else {
            if (!firstName || firstName.trim() === "") {
                setShowFirstNameError(true)
            }
            if (!mobile || mobile.trim() === "") {
                setShowMobileError(true)
            }
           /*  if (!email || !getEmailIsValid(email)) {
                setShowEmailError(true)
            }
            if (!consentChecked) {
                setShowConsentError(true)
            } */
        }
    }

    const closeForm = () => {
        setFirstName(undefined)
        setMobile(undefined)
        //setEmail(undefined)
        setShowMobileError(false)
        setShowFirstNameError(false)
        //setShowEmailError(false)
        //setShowConsentError(false)
        Analytics.getInstance().trackContactLeanModalClosed()
        onClose();
    }
    return (
        <ContactMeContainer data-attribute="contact-me">
            <Close>
                <CloseIcon onClick={() => closeForm()}/>
            </Close>
            <ContactMeContent>
                <ContactMeHeadline>Vi er her for at hjælpe dig</ContactMeHeadline>
                <ContactMeSubtitle>Snak med en rådgiver og få den løsning, der passer til dig. Udfyld formularen og vi ringer til dig. </ContactMeSubtitle>
                <ModalInputContainer>
                    <ModalInput id="name" type="text" placeholder="Dit navn" autoComplete="given-name"  
                        onChange={(e) => {
                            setFirstName(e.currentTarget.value);
                        }}
                    />
                    {showFirstNameError && (firstName === undefined || firstName === "") &&
                        <ErrorMessage>Hov, her skal dit navn stå</ErrorMessage>
                    }
                    <ModalInput id="tel" type="tel" placeholder="Dit telefonnummer" autoComplete="tel"
                        onChange={(e) => {
                            setMobile(e.currentTarget.value);
                        }}
                    />
                    {showMobileError && (mobile === undefined  || mobile === "") && 
                        <ErrorMessage>Hov, vi kan ikke ringe til dig uden telefonnummer</ErrorMessage>
                    }
                   {/*  <ModalInput
                        id="email"
                        type="email"
                        placeholder="Din email"
                        autoComplete="email"
                        value={email}
                        onChange={(e) => {
                            setEmail(e.currentTarget.value);
                            if (showEmailError) {
                                setShowEmailError(!getEmailIsValid(e.currentTarget.value));
                            }
                        }}
                    />
                    {showEmailError && <ErrorMessage>Hov, indtast en gyldig email</ErrorMessage>} */}
                </ModalInputContainer>
                {/* <div style={{ display: "flex", alignItems: "flex-start", marginBottom: "24px", marginTop: "8px" }}>
                    <input
                        type="checkbox"
                        id="acceptContact"
                        checked={consentChecked}
                        onChange={e => {
                            setConsentChecked(e.target.checked);
                            if (showConsentError) setShowConsentError(!e.target.checked);
                        }}
                        className="customCheckbox"
                    />
                    <span className="checkmark"></span>
                    <label htmlFor="acceptContact" style={{ fontSize: "12px", color: "#333", cursor: "pointer", width: "90%", textAlign: "left", marginLeft: "8px" }}>
                       Ja tak – jeg vil gerne modtage eksklusive rabatter og medlemstilbud fra Ases <a target="_blank" href="https://www.ase.dk/gdpr/ase-a-kasse-samarbejdspartnere" style={{ textDecoration: "underline" }}>fordelspartnere</a> samt udvalgte medlemsfordele fra Ase, som kan spare mig penge i hverdagen. Det er altid Ase, der kontakter mig.<br/>Jeg må kontaktes via e‑mail, sms og telefon. Mit samtykke kan altid trækkes tilbage.
                    </label>
                </div>
                {showConsentError && <ErrorMessage>Hov, du skal give samtykke for at fortsætte</ErrorMessage>} */}
                <Button className="button" onClick={checkSubmit} active={true}>Ring mig op</Button>
                <Back onClick={() => closeForm()}>Tilbage</Back>
            </ContactMeContent>
        </ContactMeContainer>
    )
}